import { Box, CircularProgress, Skeleton, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';

/** Shared message shown in the center of the skeleton. */
export function MediaInProgressMessage() {
  return (
    <Typography variant="body2" color="text.secondary">
      <FormattedMessage
        id="fragments.mediaStatus.waiting"
        defaultMessage="Generación de media en proceso"
      />
    </Typography>
  );
}

/** Same wrapper as VideoFragmentPlayerContent so skeleton matches player dimensions. */
const videoPlayerWrapperSx = {
  margin: '0 auto',
} as const;

/**
 * Video-shaped skeleton matching the fragment video player layout and aspect ratio.
 * Spinner and message are centered over the skeleton.
 */
export function VideoSkeleton({ showLoader = true }: { showLoader?: boolean }) {
  return (
    <Box sx={videoPlayerWrapperSx}>
      <Box sx={{ position: 'relative', width: '100%', aspectRatio: '16 / 9' }}>
        <Skeleton variant="rectangular" sx={{ width: '100%', height: '100%', borderRadius: 1 }} />
        <Box
          sx={{
            position: 'absolute',
            inset: 0,
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 2,
          }}
        >
          {showLoader && (
            <>
              <CircularProgress size={16} />
              <MediaInProgressMessage />
            </>
          )}
        </Box>
      </Box>
    </Box>
  );
}
